// extracted by mini-css-extract-plugin
export default {"container":"screeningSearch_container__kt85d","btn":"screeningSearch_btn__hFgFs"};